import { h, Component } from "preact";
import styles from "./ParticipantClientForms.scss";
import { Text } from "preact-i18n";
import {ThemeConfig} from "elc-theme";

export default class ParticipantClientFormsHeader extends Component {
  render () {
      const { context, textId } = this.props;
    return (
      <ThemeConfig.Consumer>
      { themeConfig => {
         return(
                  <header
              class={styles.headerTitle}
              style={`color:${
                themeConfig && themeConfig.color1
                  ? themeConfig.color1
                  : ""
              };`}
            >
              <h2>
                {
                  <Text id={textId}></Text>
                }
              </h2>
            </header>
  		 )}
      }
    </ThemeConfig.Consumer>
  )
  
  }
}